import {
	Card,
	CardHeader,
	CardFooter,
	Table,
	Container,
	Row,
	BreadcrumbItem,
	Breadcrumb,
	Input,
} from "reactstrap"
// core components
import { Component } from "react"
import { Link } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { connect } from "react-redux"
import { sacrament } from "../../../redux/actions"

class ChildSubmission extends Component {
	constructor(props) {
		super(props)

		this.state = {
			params: {
				limit: 10,
				page: 1,
			},
		}
	}

	handlePageClick(e) {
		const oldState = { ...this.state }

		oldState.params.page = e.selected + 1

		this.setState(oldState, () => {
			this.getChildSubmissions()
		})
	}

	getChildSubmissions() {
		this.props.getChildSubmissions(this.state.params)
	}

	componentDidMount() {
		this.getChildSubmissions()
	}

	render() {
		return (
			<>
				{/* Page content */}
				<Container fluid className='mb-5'>
					<div>
						<Breadcrumb>
							<BreadcrumbItem>
								<Link to='/admin/sacrament'>Sakramen</Link>
							</BreadcrumbItem>
							<BreadcrumbItem active>Penyerahan Anak</BreadcrumbItem>
						</Breadcrumb>
					</div>
					{/* Table */}
					<Row>
						<div className='col'>
							<Card>
								<CardHeader className='d-flex'>
									<h3 className='mr-auto'>Penyerahan Anak</h3>
								</CardHeader>
								<CardHeader>
									<div className='row'>
										<div className='has-search col-xl-4'>
											<span className='fa fa-search form-control-feedback'></span>
											<Input
												type='text'
												className='form-control'
												placeholder='Cari berdasarkan nama'
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														this.getChildSubmissions()
													}
												}}
												onChange={(e) => {
													this.setState({
														params: Object.assign({}, this.state.params, {
															search: e.target.value,
														}),
													})
												}}
											/>
										</div>
									</div>
								</CardHeader>
								<Table
									className='align-items-center table-flush table-striped'
									responsive
								>
									<thead className='thead-light'>
										<tr>
											<th scope='col'>No.</th>
											<th scope='col'>Nama</th>
											<th scope='col'>Tempat Lahir</th>
											<th scope='col'>Tanggal Lahir</th>
											<th scope='col'>Action</th>
										</tr>
									</thead>
									<tbody>
										{this.props.childSubmission.data.map((child, i) => (
											<tr>
												<td>
													{(this.props.childSubmission.page.currentPage - 1) *
														this.state.params.limit +
														i +
														1}
												</td>
												<td>{child.name}</td>
												<td>{child.birthplace}</td>
												<td>{child.birthdate}</td>
												<td>
													<Link
														to={{
															pathname: `/admin/sacrament/child-submission/${child.id}`,
														}}
													>
														Lihat Detail
													</Link>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
								<CardFooter className='py-4 d-flex justify-content-end align-items-center'>
									<p>
										{`Menampilkan ${this.props.childSubmission.data.length} dari ${this.props.childSubmission.page.totalData} data`}
									</p>
									<ReactPaginate
										breakLabel='...'
										nextLabel='&raquo;'
										onPageChange={this.handlePageClick.bind(this)}
										pageRangeDisplayed={1}
										pageCount={this.props.childSubmission.page.totalPage}
										marginPagesDisplayed={1}
										previousLabel='&laquo;'
										renderOnZeroPageCount={null}
										className='pagination ml-3'
										pageClassName='page-item'
										pageLinkClassName='page-link'
										activeClassName='active'
										disabledClassName='disabled'
										nextClassName='page-item'
										breakClassName='page-item'
										nextLinkClassName='page-link'
										previousClassName='page-item'
										previousLinkClassName='page-link'
										breakLinkClassName='page-link'
									/>
								</CardFooter>
							</Card>
						</div>
					</Row>
				</Container>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		childSubmission: state.childSubmission,
	}
}

const mapDispatchToProps = {
	getChildSubmissions: sacrament.getChildSubmissions,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChildSubmission)
